module.exports = __webpack_public_path__ + "static/media/sign-up.436d141f.png";